import { forwardRef, ForwardRefRenderFunction, ForwardedRef } from 'react';
import { useDeviceType } from '@vfit/shared/hooks';
import { checkIsApp } from '@vfit/consumer/data-access';
import { IModalProps } from './modal.models';
import { DefaultModal, ModalAsDrawer, ModalFullContainer } from './components';
import { CloseBtnHandle } from 'libs/shared/components/src/lib/ModalWrappers/interfaces';

// const Modal = (props: IModalProps) => {
const ModalWithRef: ForwardRefRenderFunction<CloseBtnHandle, IModalProps> = (
  props: IModalProps,
  ref: ForwardedRef<CloseBtnHandle>
) => {
  const { isTablet } = useDeviceType();
  const { show, isModalFullContainer } = props;

  if (!show) return null;
  if (checkIsApp() && !isTablet) return <ModalAsDrawer {...props} />;
  if (isModalFullContainer) return <ModalFullContainer {...props} />;

  return <DefaultModal ref={ref} {...props} />;
};

const Modal = forwardRef<CloseBtnHandle, IModalProps>(ModalWithRef);
export default Modal;

